/* eslint-disable import/prefer-default-export */
import { productSubscribedLatestStatusByCompanyId } from "@/apis"
import { groupArray } from "@/utils"
import { PRODUCT_LIST } from "../action-types/product"

export const getProductsStatusList = (companyID) => async (dispatch) => {
    const result = await productSubscribedLatestStatusByCompanyId(companyID)
    const { productSubscribedLatestStatusList } = result.data
    const resultActiveOrPendingCancel = productSubscribedLatestStatusList.filter(
        (item) => item.status && (item.status === "active" || item.Status === "pending-cancel")
    )
    const productStatusGroupByCategoryFinal = groupArray(productSubscribedLatestStatusList, "productCategory", {})
    dispatch({
        type: PRODUCT_LIST,
        payload: {
            products: productStatusGroupByCategoryFinal,
            activeProducts: resultActiveOrPendingCancel,
        },
    })
}
